import { render, staticRenderFns } from "./CloseUp.vue?vue&type=template&id=9f73ce8a&scoped=true"
import script from "./CloseUp.vue?vue&type=script&lang=js"
export * from "./CloseUp.vue?vue&type=script&lang=js"
import style0 from "./CloseUp.vue?vue&type=style&index=0&id=9f73ce8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f73ce8a",
  null
  
)

export default component.exports